<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <tabela
          :items="items"
          :loading="loading"
          @rechargeTable="getAll()"
          @switchProcessamentosExpirados="((processamentosExpirados = $event), getAll())"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import RacionalizacaoComService from '@/services/RacionalizacaoComService';
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    name: 'RacionalizacaoComHistorico',
    components: {
      Tabela: () => import('@/components/racionalizacaoCom/Tabela.vue')
    },
    mixins: [pusherMixins],
    data: () => ({
      items: [],
      loading: false,
      processamentosExpirados: false
    }),
    mounted() {
      this.subscribe();
      this.getAll();
    },
    
    beforeDestroy() {
      this.pusherChannel.unbind('refresh-racionalizacao-com');
    },
    methods: {
      subscribe() {
        this.pusherChannel.bind('refresh-racionalizacao-com', () => {
          this.getAll();
        });
      },
      getAll() {
        this.loading = true;
        RacionalizacaoComService.getAll(this.processamentosExpirados)
          .then((res) => {
            this.items = res.data.data || [];
          })
          .catch(() => this.$toast.error('Erro ao carregar execuções.', '', { position: 'topRight' }))
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
